import { CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST } from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';
import Requester from '@app/store/contract-progress/Requester';

type ContractProgressRequesterState = Requester | null;

const initialState: ContractProgressRequesterState = null;

export default function reducer(
  state: ContractProgressRequesterState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_CONTRACT_LOAD_REQUEST:
      return initialState;
    default:
      return state;
  }
}
